import React from 'react';
import glamorous from 'glamorous';
import { connect } from 'react-redux';

import { getAvatarFromQueryText } from '../../../helpers/tara';
import { getSearchLastQueryText } from '../../../reducers/search/lastQueryText';

const Container = glamorous.div(({ theme, marginRight, width }) => ({
  width: width || 72,
  flexShrink: 0,
  marginRight,
  userSelect: 'none',
}));

const Image = glamorous.img(({ theme }) => ({
  display: 'block',
  margin: '0 auto',
  width: 'auto',
  height: 'auto',
  maxWidth: '100%',
  maxHeight: 72,
}));

const TaraAvatar = (props) => {
  const {
    marginRight,
    searchLastQueryText,
    width,
    ...rest
  } = props;

  const avatarSrc = getAvatarFromQueryText(searchLastQueryText);

  return (
    <Container
      marginRight={marginRight}
      width={width}
    >
      <Image
        src={avatarSrc}
        {...rest}
      />
    </Container>
  );
};


TaraAvatar.defaultProps = {
  type: undefined,
  typeIndex: undefined,
  marginRight: 16,
};

const getState = state => ({
  searchLastQueryText: getSearchLastQueryText(state),
});

export default connect(getState)(TaraAvatar);




// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraAvatar.js